import { all, spawn } from 'redux-saga/effects';
import { authorized, unauthorized, setAuthToken } from '@ovpn-ui-toolkit/mf-common';
import { notificationsSaga, BillingEvents } from '@cloud/shared';

import { makeMfReduxActionEventSaga } from '@ovpn-ui/utils';

import authMonitorSaga from '../features/core/authMonitorSaga';

const eventSaga = makeMfReduxActionEventSaga('cloud-nav', [
    // dispatchedActions:
    setAuthToken.TRIGGER,
    authorized.SUCCESS,
    unauthorized.TRIGGER,
    BillingEvents.BILLING_OPEN_MODAL,
]);

const sagas = [eventSaga, authMonitorSaga, notificationsSaga];

export default function* () {
    yield all(sagas.map(t => spawn(t)));
}
